const groupBy = <T>(items: T[], key: (item: T) => string): [string, T[]][] => [
  ...items.reduce((groups, item) => groups.set(key(item), [...(groups.get(key(item)) ?? []), item]), new Map<string, T[]>()),
];

export { groupBy };
